import axios from "axios";
import { materialCloudServicesPath} from "../../../Constants";

const packingMaterialRestUrl = materialCloudServicesPath + '/user/job-metric-packing-material'

export default class UserJobMetricPackingMaterial {

    static async getById(materialId) {

        return axios.get(`${packingMaterialRestUrl}/by-material-id?materialId=${materialId}`);
    }
}